import React from 'react';

const tabs = [
  { key: 'all', label: 'All' },
  { key: 'Internal', label: 'Internal' },
  { key: 'External', label: 'External' },
  { key: 'Technical', label: 'Technical' },
  { key: 'Pre-GA', label: 'Pre-GA' },
];

const TenantTabs = ({ activeTab, counts, onChange }) => (
  <div className="tenant-tabs" role="tablist" aria-label="Tenant workspace tabs">
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={activeTab === tab.key}
        className={`tenant-tab ${activeTab === tab.key ? 'is-active' : ''}`}
        onClick={() => onChange(tab.key)}
      >
        {tab.label}
        <span>{counts?.[tab.key] || 0}</span>
      </button>
    ))}
  </div>
);

export default TenantTabs;
